import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  inputBase: {
    color: theme.palette.secondary.nain,
    margin: 0,
    "& .MuiInputBase-root": {
      height: [theme.spacing(15), "!important"],
    },
    "& .MuiOutlinedInput-adornedEnd": {
      padding: "0px !important",
    },
    "& .MuiButton-containedSizeSmall": {
      "& .MuiButton-containedSizeSmall": {
        padding: "0px !important",
      },
    },
    "& .MuiInputBase-input": {
      direction: "rtl !important",
      margin: [theme.spacing(0, 9), "!important"],
      fontSize: theme.fontSize["14"],
      padding: "0px !important",
      height: [theme.spacing(15), "!important"],
    },
    "& .MuiOutlinedInput-input.Mui-disabled": {
      color: [theme.palette.secondary.main, "!important"],
    },
  },
  Button: {
    backgroundColor:
      theme.palette.type === "light"
        ? [theme.palette.secondary.tint15, "!important"]
        : [theme.palette.secondary.tint60, "!important"],
    color: [theme.palette.secondary.tint40, "!important"],
    height: "100%",
    minWidth: [theme.spacing(19), "!important"],
    padding: "0px !important",
  },
}));
